import { createAsyncLocalStorage } from './async-local-storage';
export const workUnitAsyncStorageInstance = createAsyncLocalStorage();

//# sourceMappingURL=work-unit-async-storage-instance.js.map